module.exports = __webpack_public_path__ + "media/images/flags/fr-63a9ebf4fb32fcea2238d716b40507dd.svg";